import actions from './actions'

const state = {
  assets: null
}

const asset = {
  namespaced: true,
  state,
  actions
}

export default asset
